import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Country } from './countries.models';
import { COUNTRIES_FEATURE_KEY, countriesAdapter, CountriesState, selectName, sortbyCodes } from './countries.reducer';

export const selectCountriesState = createFeatureSelector<CountriesState>(COUNTRIES_FEATURE_KEY);
const { selectAll } = countriesAdapter.getSelectors();

export const isLoaded = createSelector(selectCountriesState, (state: CountriesState) => state.loaded);
export const getError = createSelector(selectCountriesState, (state: CountriesState) => state.error);
export const getAllCountries = createSelector(selectCountriesState, (state: CountriesState) =>
  sortbyCodes(selectAll(state), 'CH', 'AT', 'DE')
);
export const getAllCountryNames = createSelector(getAllCountries, (countries: Country[]) => countries.map(selectName));
